import { MAX_SESSION_PARAM_LENGTH } from './constants';

// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/g;

const sanitiseValue = value => {
  if (typeof value !== 'string') return null;
  const cleaned = value.replace(CONTROL_CHARS, '').trim().slice(0, MAX_SESSION_PARAM_LENGTH);
  return cleaned || null;
};

/**
 * The configured url params present in a query string, as prefixed properties, e.g.
 * ?offer=xmas26 with ['offer'] and 'campaign_' gives { campaign_offer: 'xmas26' }. Params that are
 * not in the url are left out, so earlier values are never cleared. Keys are matched lower case,
 * the first occurrence wins, values are trimmed and capped like the campaign plugin's
 */
export const getSessionParams = (search, params = [], prefix = '') => {
  if (typeof search !== 'string' || !search || !params.length) return {};

  return Array.from(new URLSearchParams(search).entries()).reduce((acc, [rawKey, rawValue]) => {
    const key = rawKey.trim().toLowerCase();
    const property = `${prefix}${key}`;
    if (!params.includes(key) || property in acc) return acc;

    const value = sanitiseValue(rawValue);
    return value ? { ...acc, [property]: value } : acc;
  }, {});
};

// The query string of a Next.js url or asPath, without the hash
export const getSearchFromUrl = (url = '') => {
  if (typeof url !== 'string') return '';
  const [, search = ''] = url.split('#')[0].split('?');
  return search;
};
